import { ReactNode, forwardRef } from 'react';
import { FaExclamationTriangle } from 'react-icons/fa';
import { BadgeProps, Badge } from 'theme-ui';

function resolveColor(variant) {
  switch (variant) {
    case 'alert':
      return 'red';
    default:
      return variant || 'primary';
  }
};

const Chip = forwardRef<HTMLDivElement, BadgeProps>(({
  variant,
  ...props
}: BadgeProps, ref) => {
  const color = resolveColor(variant);
  return (
    <Badge
      ref={ref}
      {...props}
      sx={{
        fontWeight: 'normal',
        borderRadius: '4px',
        display: 'inline-flex',
        alignItems: 'center',
        backgroundColor: 'transparent',
        border: '1px solid',
        borderColor: color,
        color,
        px: '4px',
        py: '2px'
      }}
    />
  );
});

export default Chip;

interface ChipWithLabelProps extends BadgeProps {
  label: ReactNode;
}

export function AlertChip({ label, ...props }: ChipWithLabelProps) {
  return (
    <Chip
      variant="alert"
      {...props}
    >
      <FaExclamationTriangle
        sx={{
          mr: 1
        }}
      />
      {label}
    </Chip>
  )
}
